{
  "name": "everest-smart-routes-user-stadistics",
  "version": "0.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:e2e": "ng serve --configuration=e2e",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "deploy:hosting:dev": "npm run build:dev && firebase deploy --only hosting:SmartRouteStatisticsDevelop",
    "deploy:hosting:prod": "npm run build:prod && firebase deploy --only hosting:SmartRouteStatisticsProd",
    "watch": "ng build --watch --configuration development",
    "test": "CHROME_BIN=chromium ng test --watch=false --browsers=ChromeHeadless",
    "test:breadcrumb": "CHROME_BIN=chromium ng test --watch=false --browsers=ChromeHeadless --include=src/app/shared/components/breadcrumb/breadcrumb.component.spec.ts",
    "check:usuarioadmin": "node scripts/check_usuarioadmin.mjs",
    "e2e": "playwright test",
    "e2e:headed": "playwright test --headed",
    "e2e:ui": "playwright test --ui"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@jsverse/transloco": "^7.5.0",
    "firebase": "^9.23.0",
    "highcharts-angular": "^4.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.0",
    "@playwright/test": "^1.58.2",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.2"
  }
}
